// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Link, Typography } from '@iheartjane/reefer';

const InlineLink = styled(Link)(({ theme }) => ({
  color: theme.colors.text.light,
  display: 'inline',
}));

const InlineBlockTypography = styled(Typography)(({ theme }) => ({
  color: theme.colors.text.light,
  display: 'inline-block',
}));

export const CaptchaPromptText = () => (
  <InlineBlockTypography textAlign="center" variant="small-body-regular">
    This site is protected by reCAPTCHA and the&nbsp;
    <InlineLink href="https://policies.google.com/privacy">
      Google Privacy Policy
    </InlineLink>
    &nbsp;and&nbsp;
    <InlineLink href="https://policies.google.com/terms">
      Terms of Service apply.
    </InlineLink>
  </InlineBlockTypography>
);
